import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_LOAN_KYC_REPORT } from "../../../Types";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const getLoanKycReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LendingReports/GetLoanKycReport`, requestData)
    .then(({ data }) => {
      if (data)
        dispatch({
          type: GET_LOAN_KYC_REPORT,
          payload: data,
        });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LendingReports/GetLoanKycReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `LOAN_KYC_Report_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "distributor"
                ? "Distributor"
                : ws[address].v == "distCenter"
                ? "Dist Center"
                : ws[address].v == "vizId"
                ? "VIZ ID"
                : ws[address].v == "shopCode"
                ? "Shop Code"
                : ws[address].v == "shopName"
                ? "Shop Name"
                : ws[address].v == "cnicNo"
                ? "CNIC No"
                : ws[address].v == "mobileNumber"
                ? "Mobile Number"
                : ws[address].v == "financier"
                ? "Financier"
                : ws[address].v == "email"
                ? "Email"
                : ws[address].v == "businessName"
                ? "BusinessName"
                : ws[address].v == "businessType"
                ? "BusinessType"
                : ws[address].v == "creditRequired"
                ? "Credit Required"
                : ws[address].v == "businessAddress"
                ? "Business Address"
                : ws[address].v == "kycStatus"
                ? "KYC Status"
                : ws[address].v == "contractStatus"
                ? "Contract Status"
                : ws[address].v == "assignLimit"
                ? "Assign Limit"
                : ws[address].v == "usedLimit"
                ? "Used Limit"
                : ws[address].v == "balance"
                ? "Balance"
                : ws[address].v == "date"
                ? "Date"
                : ws[address].v == "externalId"
                ? "External Id"
                : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data?.report, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
